export { prefersReducedMotion } from './prefersReducedMotion.ts';
